import { render, staticRenderFns } from "./CreatePage.vue?vue&type=template&id=26a8819c&scoped=true&"
import script from "./CreatePage.vue?vue&type=script&lang=js&"
export * from "./CreatePage.vue?vue&type=script&lang=js&"
import style0 from "./CreatePage.vue?vue&type=style&index=0&id=26a8819c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a8819c",
  null
  
)

export default component.exports